/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Updates_Updateready1Inputs */

const tr_updates_updateready1 = /** @type {(inputs: Updates_Updateready1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Güncelleme indirildi ve kuruluma hazır. Uygulamayı yeniden başlatın.`)
};

const en_updates_updateready1 = /** @type {(inputs: Updates_Updateready1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Update downloaded and ready for installation. Please restart the app.`)
};

/**
* | output |
* | --- |
* | "Update downloaded and ready for installation. Please restart the app." |
*
* @param {Updates_Updateready1Inputs} inputs
* @param {{ locale?: "tr" | "en" }} options
* @returns {LocalizedString}
*/
const updates_updateready1 = /** @type {((inputs?: Updates_Updateready1Inputs, options?: { locale?: "tr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Updates_Updateready1Inputs, { locale?: "tr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "tr") return tr_updates_updateready1(inputs)
	return en_updates_updateready1(inputs)
});
export { updates_updateready1 as "updates_updateReady" }